
class RRAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  shopifyProducts = [];
  errorMessage = '';

  async connectedCallback() {
    if (window.addToCartItems === undefined) {
      return;
    }
    const skus = window.addToCartItems.map(item => item.reference.replace('gid://pictofit/sku/', ''));
    var prods = {}
    var promises = [];
    for (const sku of skus) {
      const p = this.fetchProductBySKU(sku).then(product => {
        if (product) {
          prods[sku] = product;
        } else {
          console.error('Product not found in shopify', sku);
        }
      });
      promises.push(p);
    }

    Promise.all(promises).then(() => {
      var sorted = skus.map(sku => prods[sku]);
      var productsHtml = ''
      skus.forEach((sku, index) => {
        if (sorted[index] !== undefined) {
          productsHtml += this.renderProduct(sorted[index], sku);
          this.shopifyProducts.push(sorted[index]);
        }
      })
      this.innerHTML = `
      <div id="productModal" class="rr-modal" style="display: block;">
        <div class="rr-modal-content">
          <div class="modal-header">
          <button class="rr-add-to-cart-close"></button>
          <h2 class="modal-title">Add to Cart</h2> 
          </div>
          <div class="products-list">
          ${productsHtml}
          <button id="pictofit-add-to-cart-btn"><img class="add-to-cart-icon" >Add to Cart</button>
          </div>
        </div>
        <div class="add-to-cart-overlay-backdrop" >
          <div class="add-to-cart-overlay">
            The products have been added to your cart.
          </div>
        </div>
        <div class="add-to-cart-error-overlay-backdrop" onClick="this.classList.remove('visible')">
          <div class="add-to-cart-error-overlay">
            <button class="add-to-cart-error-overlay-close" onClick="this.parentNode.parentNode.classList.remove('visible')"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>
            <span class="icon__fallback-text">close</span>
            </button>
            
            <div class="add-to-cart-error-overlay-content"></div>
          </div>
      </div>`


      document.getElementsByClassName('rr-add-to-cart-close')[0].addEventListener('click', this.close.bind(this));
      document.getElementById('pictofit-add-to-cart-btn').addEventListener('click', this.addToCart.bind(this));
      const removeElements = document.getElementsByClassName('trashbutton')
      for (let element of removeElements) {
        element.addEventListener('click', this.removeProduct.bind(this));
      }
      for (let p of this.shopifyProducts) {
        this.addVariantChangeHandler(p);
      }
    });
    this.innerHTML = `
    <div id="productModal" class="rr-modal" style="display: block;">
      <div class="rr-modal-content" style="height: 90%;">
        <div class="modal-header">
        <button class="rr-add-to-cart-close"></button>
        <h2 class="modal-title">Add to Cart</h2> 
        </div>
        <div class="products-list">
           <div class="loading"> Loading products... </div>
        </div>
      </div>
    </div>`
  }

  addVariantChangeHandler(product) {
    const colorSelect = document.querySelector(`.product-container[name="${product.id}"] select[name="color"]`);
    const sizeSelect = document.querySelector(`.product-container[name="${product.id}"] select[name="size"]`);
    if(colorSelect){
      colorSelect.addEventListener('change', () => this.updateData(product, sizeSelect, colorSelect));
    }
    if(sizeSelect){
      sizeSelect.addEventListener('change', () => this.updateData(product, sizeSelect, colorSelect));
    }
  }

  updateData(product,sizeSelect, colorSelect){
    if(colorSelect !== null && sizeSelect !== null){
      const selectedColor = colorSelect.value;
      const selectedSize = sizeSelect.value;
      const colorOption = product.options.find(option => option.name.toLowerCase() === 'color');
      const sizeOption = product.options.find(option => option.name.toLowerCase() === 'size');
      const selectedVariant = product.variants.find(variant => variant["option" + sizeOption.position] === selectedSize && variant["option" + colorOption.position] === selectedColor);
      this.updateImagePrice(product, selectedVariant);
    }else if(colorSelect !== null && sizeSelect === null){
      const selectedColor = colorSelect.value;
      const colorOption = product.options.find(option => option.name.toLowerCase() === 'color');
      const selectedVariant = product.variants.find(variant => variant["option" + colorOption.position] === selectedColor);
      this.updateImagePrice(product, selectedVariant);
    }else if(sizeSelect !== null && colorSelect === null){
      const selectedSize = sizeSelect.value;
      const sizeOption = product.options.find(option => option.name.toLowerCase() === 'size');
      const selectedVariant = product.variants.find(variant => variant["option" + sizeOption.position] === selectedSize );
      this.updateImagePrice(product, selectedVariant);
    }
  }

  updateImagePrice(product, selectedVariant) {
    const productImage = document.querySelector(`.product-container[name="${product.id}"] img`);
    const price = document.querySelector(`.product-container[name="${product.id}"] .price`);
    if(selectedVariant){
      if(productImage){
        productImage.src = selectedVariant.featured_image?selectedVariant.featured_image.src : product.images.length>0?product.images[0]:'';
      }
      if(price){
        price.innerHTML = `${theme.Currency.formatMoney(selectedVariant.price)}`
      }
    }
  }


  ondisconnectedCallback() {
    this.shopifyProducts = [];
  }

  close() {
    this.remove();
  }

  async addToCart() {
    let toBeAdded = [];
    const products = document.getElementsByClassName('product-container');
    for (let i = 0; i < products.length; i++) {
      const productId = products[i].getAttribute('name');
      const size = this.querySelector(`.product-container[name="${productId}"] select[name="size"]`)?.value;
      const color = this.querySelector(`.product-container[name="${productId}"] select[name="color"]`)?.value;
      const selectedQuantity = this.querySelector(`.product-container[name="${productId}"] select[name="quantity"]`)?.value;
      const shopifyProduct = this.shopifyProducts.filter(p => p.id.toString() === productId)[0];
      let productvariants = shopifyProduct.variants;
      const sizeOption = shopifyProduct.options.find(option => option.name.toLowerCase() === 'size');
      const colorOption = shopifyProduct.options.find(option => option.name.toLowerCase() === 'color');
      if (sizeOption) {
        productvariants = productvariants.filter(v => v[`option${sizeOption.position}`] === size);
      }
      if (colorOption) {
        productvariants = productvariants.filter(v => v[`option${colorOption.position}`] === color);
      }
      console.log("product to be added: ", productvariants)
      toBeAdded.push({ quantity: parseInt(selectedQuantity) ?? 1, id: productvariants[0].id });
    }
    this.addToShopifyCart(toBeAdded)
      .then(res => {
        if (res.status === 200) {
          this.showSuccessOverlay();
          setTimeout(() => {
            //custom event to update cart drawer
            const event = new Event("cart:build");
            document.dispatchEvent(event);
            this.close();
          }, 2000);
        } else if(res.status === 422){
          res.json().then(data => {
            console.error("Error adding to cart data (422)", data);
            this.showErrorOverlay(data.message);
          })
        }
      })
      .catch(err => {
        console.error("Error adding to cart", err);
      });
  }

  showSuccessOverlay() {
    const overlay = document.querySelector('.add-to-cart-overlay-backdrop');
    //overlay.style.visibility = 'visible';
    overlay.classList.add('visible');
  }

  showErrorOverlay(message) {
    const overlay = document.querySelector('.add-to-cart-error-overlay-backdrop');
    const error = document.querySelector('.add-to-cart-error-overlay-content');
    error.innerHTML = '<p>The products could not be added to you cart: </p>'
    error.innerHTML += message;
    //overlay.style.visibility = 'visible';
    overlay.classList.add('visible');
  }

  async fetchProductBySKU(sku) {
    //use predictive search api to get the product handle by SKU
    const query = encodeURIComponent(sku);
    const response = await fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=variants.sku`);
    const data = await response.json();
    if (!data.resources.results.products.length) {
      return null;
    }

    const matchingProduct = data.resources.results.products[0]
    // use the ajax api to get the product belonging to the variant SKU
    const productHandle = matchingProduct.handle;
    const productDetails = await fetch(`/products/${productHandle}.js`).then(res => res.json());
    return productDetails;
  }

  async fetchCurrency() {
    const cart = await fetch('/cart.js').then(res => res.json());
    return cart.currency;
  }
  async addToShopifyCart(data) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: data }),
    });
    return response;
  }

  removeProduct($event) {
    const productId = $event.srcElement.name;
    const product = document.querySelector(`.product-container[name="${productId}"]`);
    if (product) {
      product.remove();
    }
  }

  renderProduct(product, sku) {
    const sizeOption = product.options.find(option => option.name.toLowerCase() === 'size');
    const colorOption = product.options.find(option => option.name.toLowerCase() === 'color');
    let sizeVariants = undefined;
    let selected_variant = product.variants.filter(variant => variant.sku === sku);
    if (sizeOption) {
      const option = "option" + sizeOption.position;
      sizeVariants = [...new Set(product.variants.map(variant => variant[option]))];
    }
    let colorVariants = undefined

    if (colorOption) {
      const option = "option" + colorOption.position;
      const p_variants = product.variants.filter(variant => variant.sku !== sku);
      selected_variant = product.variants.filter(variant => variant.sku === sku);
      colorVariants = [...new Set([...selected_variant, ...p_variants].map(variant => variant[option]))];
    }

    return `
      <div class="product-container" name="${product.id}">
        <img src="${(selected_variant && selected_variant.length > 0 && selected_variant[0].featured_image) ? selected_variant[0].featured_image?.src : product.featured_image}" alt="${product.title}" class="product-image">
        <div class="product-info">
          <div class="product-column1">
            <span class="product-title">${product.title}</span>
            
            ${(colorOption && colorVariants) ? `
            <div class="optionSelection">
              <label for="${colorOption.name}">${colorOption.name}</label>
            <select id="${colorOption.name}" class="${colorVariants.length < 2 ? 'noArrow' : ''}" name="${colorOption.name.toLowerCase()}" ${colorVariants.length < 2 ? 'disabled' : ''}>
              ${colorVariants.map(value => `
                    <option value="${value}">${value}</option>
                `).join('')
        }
            </select></div>`: ''
      }
            <div class="optionSelection"> 
            <label for="quantity">Quantity</label>
            <select id="quantity" name="quantity">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>
            </div>

            <button name="${product.id}" class="trashbutton full-trashbutton"></button>
          </div>
          
          <div class="product-column2">
            ${(sizeOption && sizeVariants) ? `
        
            <label class="size-label" for="${sizeOption.name}">${sizeOption.name}</label>
            <select class="size-select ${sizeVariants.length < 2 ? 'noArrow' : ''}" id="${sizeOption.name}" name="${sizeOption.name.toLowerCase()}" ${sizeVariants.length < 2 ? 'disabled' : ''}>
            ${sizeVariants.map(value => `
              <option value="${value}">${value}</option>
              `).join('')
        }
            </select>`: ''}
          </div>
          
            <div class="product-column3">
              <div class="column3-price">
              <span class="price">${theme.Currency.formatMoney(selected_variant[0].price)}</span>
              <span class="price_info">Unit price incl. VAT</span>
              </div>
              <div class="column3-trash">
                <button name="${product.id}" class="trashbutton"></button>
              </div>
            </div>
        </div>
      </div>
  `;
  }

}
customElements.define('rr-add-to-cart', RRAddToCart);
